<template>
    <div>
        <div ref="parentContainer" class="container-height container-scroll border-left border-right">
            <div class="d-flex flex-column">
                <div ref="tableHeader" class="table-headers d-inline-flex" :style="{width: headerWidth}">
                    <div class="table-cell sticky-column-header border-bottom border-right">
                        <a href="javascript:void(0)" @click="onFieldClick(primaryField)">

                            <div class="pt-1 d-flex align-items-center">
                                <i class="fal fa-xs me-2" :class="getClass(primaryField)" style="color: #888888"> </i>
                                <div style="line-height: 1.2;"> {{primaryField.name}}</div>
                            </div>

                        </a>
                    </div>

                    <div v-for="field in fields" class="table-header-cell border-right border-bottom">

                            <div class="dropdown header-dropdown">

                                <a class="dropdown-toggle no-underline" href="javascript:void(0)" role="button"
                                   data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                                    <div class="pt-1 d-flex align-items-center">
                                        <i class="fal fa-xs me-2" :class="getClass(field)" style="color: #888888;"> </i>
                                        <div class="me-2 table-header-content" style="min-width: 0; line-height: 1.2;">{{field.name}}</div>
                                        <i class="fas fa-caret-down fa-xs text-black-50"></i>
                                    </div>

                                </a>

                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <h6 class="dropdown-header">Field</h6>

                                    <div  @click="onFieldClick(field)" class="pointer dropdown-item">
                                        <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                                        <a class="no-underline menu-link" href="javascript:void(0)">Edit</a>
                                    </div>

                                    <div @click="onDeleteFieldClick(field.id)" class="pointer dropdown-item">
                                        <i class="fal fa-trash-alt text-secondary me-1 menu-icon"></i>
                                        <a class="no-underline menu-link" href="javascript:void(0)">Delete</a>
                                    </div>
                                </div>
                            </div>

                    </div>

                    <div class="table-cell table-header-cell">
                        <a href="javascript:void(0)" @click="onNewFieldClick()" class="text-primary no-underline">
                            <i class="fad fa-plus-circle"></i>
                        </a>
                    </div>
                </div>

                <div v-for="document in documents" class="table-row border-bottom d-inline-flex" :style="{width: tableRowWidth}">

                    <primary-cell :document="document" :field="primaryField"
                                  @cellCtrlClick="onCellCtrlClick"
                                  @documentClicked="onDocumentClick"
                                  @deleteDocumentClicked="onDeleteDocumentClick"></primary-cell>

                    <div v-for="field in fields" class="table-cell border-right">
                        <field-cell-renderer :key="document['id']" :document="document" :field="field" :table="table"></field-cell-renderer>
                    </div>
                </div>

                <div style="height: 10px;"></div>

                <div class="d-inline-flex text-primary" :style="{width: tableRowWidth}">
                    <div class="table-cell sticky-row py-2 px-3">
                        <div @click="onNewClick()" class="pointer">
                            <i class="fad fa-plus-circle"></i> new
                        </div>

                    </div>
                </div>

            </div>


        </div>

		<div class="light-background py-1 ps-2">
			{{documents.length}} records
		</div>

        <field-modal :key="'fields-on-grid-' + table.id" v-if="showFieldEditor" :table="table"
                     :field="currentField" @noEvent="showFieldEditor = false"></field-modal>

        <form-modal v-if="showFormModal" @noEvent="showFormModal = false" :table="table" :document="currentDocument"
                    :yesEvent="onDocumentSave"></form-modal>

        <confirm-modal key="deleteDocumentModal"
                       v-if="showConfirmDeleteModal"
                       @noEvent="showConfirmDeleteModal = false"
                       :yesEvent="onDeleteConfirmed"
                       text="Are you sure you want to delete this data?">
        </confirm-modal>

        <confirm-modal key="deleteFieldModal"
                       v-if="showConfirmDeleteFieldModal"
                       @noEvent="showConfirmDeleteFieldModal = false"
                       :yesEvent="deleteField"
                       text="Are you sure you want to delete this field?">
        </confirm-modal>

<!--        <vue-context :key="'cellContextMenu'" ref="cellMenu">-->
<!--            <li>-->
<!--                <a href="javascript:void(0)" @click.prevent="onDeleteDocumentClick(currentDocument)">-->
<!--                    <i class="fal fa-trash-alt"></i> Delete record-->
<!--                </a>-->
<!--            </li>-->
<!--            <li v-if="pdfExportAvailable">-->
                <pdf-link :table="table" :document="currentDocument"></pdf-link>
<!--            </li>-->
<!--        </vue-context>-->

        <vue-simple-context-menu
                element-id="myUniqueId"
                :options="contextMenuOptions"
                ref="vueSimpleContextMenu"
                @option-clicked="onContextOptionClicked"
        />

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import FieldModal from "../../editor/app/FieldModal.vue";
    import FormModal from "../form/FormModal.vue";
    import TableUtil from "../../utils/TableUtil";
    import PrimaryCell from "./PrimaryCell.vue";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import DataService from "../../services/DataService";
    import FieldCellRenderer from "../renderers/FieldCellRenderer.vue";
    import ViewUtil from "../../utils/ViewUtil";
    import FieldService from "../../services/FieldService";
    import PdfLink from "../../components/PdfLink.vue";

    export default {
        name: 'GridView',
        components: {PdfLink, FieldCellRenderer, ConfirmModal, PrimaryCell, FormModal, FieldModal},
        props: ['table', 'view', 'showHeader', 'parentTable', 'parentDocument'],
        data() {
            return {
                model: webase.model,
                dataService: new DataService(this.table.id),
                viewUtil: new ViewUtil(this.table, this.view),
                documents: [],
                currentField: {
                    name: '',
                    field_type: 'String',
                    model_id: '',
                    metadata: '',
                    required: false,
                    id: null
                },
                showFieldEditor: false,
                currentDocument: null,
                showFormModal: false,
                onDocumentSave: function () {
                },
                showConfirmDeleteModal: false,
                onDeleteConfirmed: function () {
                },
                showConfirmDeleteFieldModal: false,
                deleteField: function () {
                }
            }
        },
        computed: {
            contextMenuOptions() {
                return this.pdfExportAvailable ? [{name: 'Delete Record'}, {name: 'Export to PDF'}] : [{name: 'Delete Record'}]
            },
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            fields() {
                return this.table.fields.slice(1)
            },
            headerWidth() {
                return ((this.table.fields.length + 1) * 200) + 'px'
            },
            tableRowWidth() {
                return (this.table.fields.length * 200) + 'px'
            },
            pdfExportAvailable() {
                if (this.hasRelatedTable) {
                    let relatedTable = webase.managers.app.getTable(this.relatedTableId)
                    return webase.utils.table.supportsPdf(relatedTable)
                }

                return false
            },
            hasRelatedTable() {
                return this.linkedObjectField !== null
            },
            linkedObjectField() {
                return webase.utils.table.getLinkedObjectField(this.table)
            },
            relatedTableId() {
                return this.linkedObjectField.related_model_id
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)

            // console.log('Grid mounted')
            // console.log('Container W: ' + this.$refs.parentContainer.clientWidth)
            // console.log('Table W: ' + this.$refs.tableHeader.clientWidth)

            // $(function () {
            //     $('[data-bs-toggle="popover"]').popover()
            // })
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            onCellCtrlClick(event, document) {
                this.currentDocument = document
                // this.$refs.cellMenu.open(event)
                this.$refs.vueSimpleContextMenu.showMenu(event, document)
            },
            onContextOptionClicked(event) {
                console.log(event)
                let document = event.item
                let command = event.option.name
                console.log(command)

                if(command === 'Delete Record') {
                    this.onDeleteDocumentClick(document)
                }
                else if(command === 'Export to PDF') {
                    let pdfLink = webase.utils.table.pdfLink(this.table, document)
                    window.open(pdfLink, '_blank')
                }

                // window.alert(JSON.stringify(event))
            },
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table, this.parentDocumentId).then((response) => {
                    this.documents = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            onNewClick() {
                let tableUtil = new TableUtil()
                this.currentDocument = tableUtil.createRecord(this.table)

                if(this.viewUtil.hasLinkedObjectFilter()) {
                    this.viewUtil.setLinkedObjectFilterData(this.currentDocument, this.openFormModal)
                    return
                }

                this.openFormModal()
            },
            openFormModal() {
                this.showFormModal = true

                this.onDocumentSave = () => {
                    let service = new DataService(this.table.id)
                    service.save(this.currentDocument).then((savedDocument) => {
                        this.documents.push(savedDocument)
                    })
                }
            },
            onDocumentClick(document) {
                this.currentDocument = document
                this.showFormModal = true

                this.onDocumentSave = () => {
                    let service = new DataService(this.table.id)
                    service.save(document)
                }
            },
            onDeleteDocumentClick(document) {
                console.log('parent onDeleteDocumentClick')
                this.showConfirmDeleteModal = true

                this.onDeleteConfirmed = () => {
                    this.dataService.remove(document).then((response) => {
                        this.showConfirmDeleteModal = false
                        webase.utils.array.remove(this.documents, document['id'])
                    }).catch((message) => {
                        console.log('error deleting document')
                        console.log(message)
                        this.showConfirmDeleteModal = false
                    })
                }
            },
            onPdfClick(document) {

            },
            onFieldClick(field) {
                this.currentField = field
                this.showFieldEditor = true
            },
            onNewFieldClick() {
                this.currentField = {
                    name: '',
                    field_type: 'String',
                    model_id: this.table.id,
                    child_model_id: null,
                    required: false,
                    id: null
                }

                this.showFieldEditor = true
            },
            getClass(field) {
                return webase.utils.ui.getClass(field)
            },
            onDeleteFieldClick(fieldId) {
                let fieldService = new FieldService()
                this.showConfirmDeleteFieldModal = true

                this.deleteField = () => {
                    fieldService.remove(fieldId).then(() => {
                        webase.utils.array.remove(this.table.fields, fieldId)
                        this.showConfirmDeleteFieldModal = false
                    }).catch((error) => {
                        console.log('Error removing field.')
                        console.log(error)
                        this.showConfirmDeleteFieldModal = false
                    })
                }
            }
        }
    }
</script>
